import { Accordion, Title } from '@mantine/core';
import React from 'react';

import { TaskContent } from '../../../../shared/model/tasks/types';
import { Attribute } from '../../../../shared/ui/Attribute';
import styles from './TaskAttributes.module.css';

type Props = {
  attributes: TaskContent[];
};

export const TaskAttributes: React.FC<Props> = ({ attributes }) => {
  return (
    <>
      <Title data-id="attrTitle" fw={400} mb="sm" mt="xs" order={3}>
        Атрибуты
      </Title>
      {attributes.slice(0, 3).map((field) => (
        <Attribute field={field} key={field.idField} />
      ))}
      <Accordion
        className={styles.root}
        classNames={{
          label: styles.accordionLabel,
        }}
      >
        <Accordion.Item data-id="allAttrs" value="group">
          <Accordion.Control>Все аттрибуты</Accordion.Control>
          <Accordion.Panel>
            {attributes.slice(3).map((field) => (
              <Attribute field={field} key={field.idField} />
            ))}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
